(() => {
  'use strict';
  if (window.AUNoirCardImages) return;

  const GALLERY = '.product-card__media--gallery';
  const SOURCE = 'img[data-au-image-src]';
  const mobile = matchMedia('(max-width: 699px)');
  const pending = new WeakMap();
  let resizeTimer;

  function sizeImage(image) {
    const width = image.closest(GALLERY)?.clientWidth;
    if (width > 0) image.sizes = `${Math.ceil(width)}px`;
  }

  function loadImage(image) {
    if (!image?.matches(SOURCE)) return Promise.resolve(true);
    if (pending.has(image)) return pending.get(image);
    const promise = new Promise(resolve => {
      const finish = success => {
        image.removeEventListener('load', onLoad);
        image.removeEventListener('error', onError);
        if (success) {
          image.removeAttribute('data-au-image-pending');
          image.removeAttribute('data-au-image-src');
          image.removeAttribute('data-au-image-srcset');
        } else pending.delete(image);
        resolve(success);
      };
      const onLoad = () => finish(image.naturalWidth > 0);
      const onError = () => finish(false);
      image.addEventListener('load', onLoad);
      image.addEventListener('error', onError);
      image.setAttribute('data-au-card-image-active', '');
      sizeImage(image);
      image.decoding = 'async';
      image.fetchPriority = 'low';
      image.loading = 'eager';
      if (image.dataset.auImageSrcset) image.srcset = image.dataset.auImageSrcset;
      image.src = image.dataset.auImageSrc;
    });
    pending.set(image, promise);
    return promise;
  }

  function loadGallery(gallery, all = false) {
    if (!gallery) return;
    if (all) gallery.querySelectorAll(SOURCE).forEach(loadImage);
    else if (gallery.closest('.product-card__media-gallery--has-secondary')) {
      loadImage(gallery.querySelector('.product-card__image--secondary'));
    }
  }

  document.addEventListener('pointerover', event => {
    if (event.pointerType === 'touch' || mobile.matches) return;
    const figure = event.target.closest?.('.product-card__figure');
    if (!figure || figure.contains(event.relatedTarget)) return;
    loadGallery(figure.querySelector(GALLERY));
  }, { passive: true });

  document.addEventListener('pointerdown', event => {
    if (mobile.matches) loadGallery(event.target.closest?.(GALLERY), true);
  }, { passive: true });

  document.addEventListener('focusin', event => {
    const gallery = event.target.closest?.(GALLERY);
    if (gallery) loadGallery(gallery, mobile.matches);
  });

  document.addEventListener('au:native-linked-product:change', event => {
    const figure = event.target.querySelector?.('.product-card__figure');
    if (!mobile.matches && figure?.matches(':hover')) loadGallery(figure.querySelector(GALLERY));
  });

  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      document.querySelectorAll('img[data-au-card-image-active]').forEach(sizeImage);
    }, 150);
  }, { passive: true });

  window.AUNoirCardImages = { loadImage };
})();
